import { browserCookie } from "@/utils/browserCookie";
import { CONSENT_COOKIE_KEY } from "./constants";

export const getConsentCookie = (): string | undefined =>
  browserCookie.get(CONSENT_COOKIE_KEY);
